import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useTrustedContactsStore = defineStore(
  'trusted-contacts-store',
  () => {
    const showOnlyCompanySkills = ref(false)

    function $reset() {
      showOnlyCompanySkills.value = false
    }

    return { showOnlyCompanySkills, $reset }
  },
)
